/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { SubEvaluationResult } from './subEvaluationResult';
import type { OralExamEvaluationResultGrade } from './oralExamEvaluationResultGrade';

/**
 * Response from POST .../oral-exam-evaluation.
 */
export interface OralExamEvaluationResult {
  subEvaluations: SubEvaluationResult[];
  grade: OralExamEvaluationResultGrade;
  overallJustification: string;
  promptVersion: string;
}
